module.exports = __webpack_public_path__ + "files/db604f5eff0a236786063d8e8d533587.png";